import React from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            display: 'flex',
            alignItems: 'center',
        },
        wrapper: {
            margin: theme.spacing(1),
            position: 'relative',
        },
        buttonProgress: {
            color: green[500],
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,
        },
    });
});
var LoadingButton = function (_a) {
    var messageId = _a.messageId, loading = _a.loading, disabled = _a.disabled, onClick = _a.onClick;
    var classes = useStyles({});
    var t = useTranslation().t;
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.wrapper },
            React.createElement(Button, { color: "primary", disabled: disabled || loading, onClick: onClick }, t(messageId)),
            loading && (React.createElement(CircularProgress, { size: 24, className: classes.buttonProgress })))));
};
export default LoadingButton;
//# sourceMappingURL=index.js.map